import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { BarcodeDialog } from './barcode.dialog.component';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { DefaultSlipAmount, MinSlipAmount } from '@environments/environment';

import { timer, Subscription, interval, Subject, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { GroupByEventName } from '@pipes/groupbyeventname.pipe';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { Location } from '@angular/common';
import { ConsentScreenDialog } from './consent-screen-dialog.component';
import { pushToDataLayer } from '@helpers/gtm.util';
import { DataService } from '@services/data.service';
import { WalletControl } from '@pipes/walletControl.pipe';
import { DepositLimitDialog } from './deposit-limit.dialog';
import { TerminalPeruPrintComponent } from '@app/sharedTemplates/print/terminalPeru/terminalPeru-print.component';

declare let gtag;

@Component({
  selector: 'current-slip-core',
  templateUrl: '../sharedTemplates/current-slip.core.html',
})
export class CurrentSlipCore implements OnInit, OnDestroy, AfterViewInit {
  _GroupByEventName = new GroupByEventName();

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    public _DataHelper: DataHelper,
    private _DataService: DataService,
    public dialog: MatDialog,
    private _location: Location
  ) {
    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        // console.log('%c stopped hold ', 'color: red; font-weight: bold');
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );

    // IOS 15 için Kontrol yapılıyor. Safari de IOS 15 te Submit Bet in üstünde siyah bir bar çıkıyor.
    const platform = navigator.platform;

    function iOSversion() {
      if (platform == 'iphone' || platform == 'Iphone') {
        const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || (0 as any), 10)];
      } else {
        return [0];
      }
    }

    const ver = iOSversion();

    if (ver[0] >= 15) {
      this.ios15 = true;
    } else {
      this.ios15 = false;
    }

    this._DataService.setDataGetter('getCurrentSlipAmount', 10);
    this._DataService.setDataGetter('refreshCurrentSlip', 10);
  }

  // bet300
  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  // bet3000
  today = new Date();

  currentSlipList = [];
  currentSlipListLength = 0;
  slipsList = [];
  //
  public BettingSlip_Countdown = 5;
  private timer;
  public timer_subscription: Subscription;
  //
  stakePerBet = 0;
  //
  systemItems = [];
  totalStakeKeyboard = '';
  tax = '';

  windowsH = 0;
  error_oddrefresherror = false;

  isMobileView = false;

  @Output() closeInformerModal: EventEmitter<any> = new EventEmitter();

  @ViewChild('focusElem1', { read: ElementRef })
  focusElem1: ElementRef;
  @ViewChild('focusElem2', { read: ElementRef })
  focusElem2: ElementRef;
  @ViewChild('focusElem3', { read: ElementRef })
  focusElem3: ElementRef;

  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;

  ios15 = false;

  private subscriptionsToStopOnDestroy: Subscription[] = [];
  lastSlipLength = 0;

  // iOSversion() {
  //   if (/iP(hone|od|ad)/.test(navigator.platform)) {
  //     // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
  //     let v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
  //     return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  //   }
  // }
  //

  keyboardIsOpen = false;

  stakeString = '';

  topLeaguesData: Array<ITopLeagues> = [];
  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;
  openedPanelId;

  // detecting current slip data changing
  oldCurrenSlipDataLength = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    ////// console.log("resized", window.innerWidth, window.innerHeight);
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('mousedown', ['$event'])
  onHold(e) {
    // console.log('className',(event.target as Element).className)
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24v2') {
      return '';
    }

    // console.log('%c started hold ', 'color: #5fba7d; font-weight: bold')
    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            const translator = new TranslatePipe(this._LocalizationService);
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = translator.transform(result.message, null);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                  this.signOut();
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }

  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }
  refreshAPP() {
    window.location.href = '/home';
  }
  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.numberOfBetsListener.subscribe(x => {
        // this.getCurrentSlip();
        this._DataHelper.currentSlipData.length = x;
        // console.warn("currentSlipListLength", this._DataHelper.currentSlipData.length, this.lastSlipLength);
        if (this._DataHelper.currentSlipData.length < 2) {
          this._UiHelper.currentSlipTabSelected = 0;
        }
        // If previous state single bet
        if (this.lastSlipLength == 1 && this._DataHelper.currentSlipData.length > 1) {
          this._UiHelper.currentSlipTabSelected = 1;
        }
        if (this.lastSlipLength == 0 && this._DataHelper.currentSlipData.length > 1) {
          this._UiHelper.currentSlipTabSelected = 1;
        }
        this.lastSlipLength = this._DataHelper.currentSlipData.length;
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.currentSlipDataListener.subscribe(x => {
        if (
          this._DataHelper.currentSlipData.length > 0 &&
          this.oldCurrenSlipDataLength !== this._DataHelper.currentSlipData.length &&
          this._UiHelper.currentSlipHeaderTabSelected === 1 &&
          this._UiHelper.currentSlipTabSelected === 2
        ) {
          this.getSystemItems();
          this.oldCurrenSlipDataLength = this._DataHelper.currentSlipData.length;
        }
        this._DataService.fireApiCall('getCurrentSlipAmount');
      })
    );

    if (this.windowsH === 0) {
      this.windowsH = this._UiHelper.windowsHeight;
    }
    this._UiHelper.windowResized.subscribe(x => {
      this.windowsH = x.h;
    });

    this.subscriptionsToStopOnDestroy.push(
      this._UserHelper.signInListener.subscribe(signin => {
        if (this._UserHelper.isSignedIn) {
          this._ApiService.getCashoutSlipsExternal(1).then();
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(this._DataHelper.numberOfCashoutListener.subscribe());

    // B3000
    this.getTopLeague();

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        if (x.w <= 990) {
          this.isMobileView = true;
          this._UiHelper.currentSlipHeaderTabSelected = 1;
        } else {
          this.isMobileView = false;
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.currentSlipTabSelectedListener.subscribe(x => {
        if (this._UiHelper.currentSlipTabSelected === 2) {
          this.getSystemItems();
        }
      })
    );
  }

  /*
// todo kaldırıldı
    this._ApiService.getSelfLimits().then(x => {
      if (
        x &&
        x.length > 0 &&
        x[0].DepositMonthlyLimitConsumed === null &&
        ((this._DataHelper.selectedWallet.BranchType == 1 && walletControl.transform(true, 'IsVerification')) || this._DataHelper.selectedWallet.BranchType == 2)
      ) {
        const dialogRef = this.dialog.open(DepositLimitDialog, {
          width: '550px',
          panelClass: 'transcationDialog',
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe();
        this._DataHelper.depositLimitDialogState = false;
      }
    });
  }

 */

  ngAfterViewInit() {
    setTimeout(x => {
      this._ApiService.loadSavedSlip();
    }, 3000);

    this.getCurrentSlip(this._ApiService.slipCurrents);
    this._UiHelper.currentSlipTabSelected = 1;
  }

  getCurrentSlip(x) {
    this._DataHelper.currentSlipData.length = x.length;
    this.currentSlipList = x;
    if (!this._UiHelper.checkboxAcceptOdds) {
      this.currentSlipList.forEach(item => {
        if (item.FirstOddValue1 !== undefined && item.FirstOddValue1 != item.OddValue1) {
          this._DataHelper.currentSlipInfo.oddIsChange = true;

          this._DataHelper.ChangeOddIsActive = true;
          this._UiHelper.placeBetIsActive = false;
        }
      });
    }

    this._changeDetection.detectChanges();
    // this._DataService.fireApiCall('getCurrentSlipAmount');

    // Live Odds Control
    const visibilityindex = this.currentSlipList.findIndex(v => {
      return v.Visibility == 'hidden';
    });

    if (visibilityindex > -1) {
      this.error_oddrefresherror = true;
    } else {
      this.error_oddrefresherror = false;
    }
  }

  keyEvent(e) {
    this.focusElem1.nativeElement.blur();
    this.focusElem2.nativeElement.blur();
    this.focusElem3.nativeElement.blur();
  }

  changeStakePerBetInput() {
    this._DataHelper.currentSlipInfo.currentslip_totalStake = this.stakePerBet * this._DataHelper.currentSlipData.length;
  }

  openBarcodeDialog(SuccessBarcode): void {
    // console.warn("SuccessBarcode",SuccessBarcode)

    const dialogRef = this.dialog.open(BarcodeDialog, {
      maxWidth: '100%',
      width: '100%',
      height: '90%',
      maxHeight: '90%',
      disableClose: true,
      data: { barcode: SuccessBarcode, type: 'VorabTicket' },
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }
  openPrintTicketDialog(SuccessBarcode): void {
    const dialogRef = this.dialog.open(TerminalPeruPrintComponent, {
      width: '700px',
      height: '50%',
      panelClass: 'transcationDialog-test',
      data: { barcode: SuccessBarcode, type: 'printTicket' },
    });
  }
  apiPlaceBetTemp(systemValues) {
    //Place Bet
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService
      .placeBetTemp(this._DataHelper.currentSlipInfo.toPayNumeric, this._UiHelper.currentSlipTabSelected, systemValues)
      .then(data => {
        if (data.body == '') {
          return 'error|System Error';
        } else {
          //console.log("----ERRORRR",data.body);

          if (data.body.split('|')[0] == 'error') {
            this._UiHelper.errorSnackBar(data.body.split('|')[1], '');
          } else if (data.body.split('|')[0] == 'errorcode') {
            const t_message = translator.transform(data.body.split('|')[1], null);
            this._UiHelper.errorSnackBar(t_message, '');
          } else if (data.body.split('|')[0] == 'success') {
            // const t_message = translator.transform('successcode2', null);
            // this._UiHelper.successSnackBar(t_message, '');
            const barcode = '500' + data.body.split('|')[2].toString();
            this.openBarcodeDialog(barcode);

            this._ApiService.getSelectedOdds();
            // this.bottomSheetRef.dismiss();

            this.closeInformerModal.emit(true);
          } else {
            this._UiHelper.errorSnackBar(data.body, '');
          }
        }
      })
      .finally(() => this._UiHelper.setLoadingDialog(false));
    //Place Bet
  }

  placeBetTemp() {
    this._UiHelper.setLoadingDialog(true);
    let systemValues = '';
    this.systemItems.forEach(cb => {
      if (cb.selected) {
        systemValues += '1,';
      } else {
        systemValues += '0,';
      }
    });
    if (systemValues != '') {
      systemValues = systemValues.substring(0, systemValues.length - 1);
    }

    if (this.timer_subscription != undefined) {
      this.timer_subscription.unsubscribe();
    }
    this.apiPlaceBetTemp(systemValues);
  }

  changeTotalStakeInput() {
    this.stakePerBet = this._DataHelper.currentSlipInfo.currentslip_totalStake / this._DataHelper.currentSlipData.length;

    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  removeOdd(oddId) {
    this._ApiService.currentSlipRemoveOdd(oddId);

    if (this._DataHelper.currentSlipData.length <= 1) {
      this._DataHelper.ChangeOddIsActive = true;
      this._UiHelper.placeBetIsActive = false;
      this.closeInformerModal.emit(true);
    }
  }

  removeAll() {
    this._DataHelper.currentSlipInfo.oddIsChange = false;
    this._DataHelper.ChangeOddIsActive = true;
    this._UiHelper.isLugasErrorActive = false;
    this._UiHelper.isLugasError5minute = false;

    this._ApiService.clearCurrentSlip();
    this._ApiService.clearSlipSystem();

    this.closeInformerModal.emit(true);
  }

  closeBottomSheet(): void {
    // todo Output
    this.closeInformerModal.emit(true);
  }

  checkIsSystem(): boolean {
    return this._DataHelper.currentSlipSystemInfo.filter(i => i.selected === true).length > 0;
  }

  // todo to be deleted
  getCurrentSlipAmount() {
    /*
        let systemValues = '';
        this.systemItems.forEach((cb) => {
          if (cb.selected) {
            systemValues += '1,';
          } else {
            systemValues += '0,';
          }
        });
        if (systemValues != '') {
          systemValues = systemValues.substring(0, systemValues.length - 1);
        }

        if (this._DataHelper.taxRate != 0) {
          // this.totalStake = ((this.totalStake * 100) / (100 + this._DataHelper.taxRate));
          // this._DataHelper.currentSlipInfo.toPay = ((this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) / (100 + this._DataHelper.taxRate));
          this._DataHelper.currentSlipInfo.toPayNumeric =
            (this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) /
            (100 + this._DataHelper.taxRate);
          this.tax = (
            this._DataHelper.currentSlipInfo.currentslip_totalStake - this._DataHelper.currentSlipInfo.toPayNumeric
          ).toFixed(4);
          // console.warn("Tax", this.tax, this._DataHelper.currentSlipInfo.toPayNumeric );
        } else {
          this._DataHelper.currentSlipInfo.toPay = this._DataHelper.currentSlipInfo.currentslip_totalStake;
          this._DataHelper.currentSlipInfo.toPayNumeric = this._DataHelper.currentSlipInfo.toPay;
          this.tax = '';
        }

        this._ApiService
          .getCurrentSlipAmount(
            this._DataHelper.currentSlipInfo.toPayNumeric,
            this._UiHelper.currentSlipTabSelected,
            systemValues
          )
          .then((calc) => {
            if (calc != null) {
              let result = {
                AmountPerBet: 0,
                NumberOfBets: 0,
                ToPay: 0,
                MaxGain: 0,
                MinGain: 0,
                TotalRate: 0,
              };
              if (calc.length > 0) {
                result = calc[0];
              }

              this.amountPerBet = result.AmountPerBet;
              this.numberOfBets = result.NumberOfBets;
              // this._DataHelper.currentSlipInfo.currentslip_totalStake = result.ToPay;
              this._DataHelper.currentSlipInfo.toPay = result.ToPay;
              this.maxGain = result.MaxGain;
              this.minGain = result.MinGain;
              this.totalRate = result.TotalRate;
              // todo bu zaten tanımlı değil ki?
              // this._UiHelper.currentTotalRate = result.TotalRate;
              this._DataHelper.currentSlipOpened = true;
              // this.getSystemItems();

              // console.warn(this.totalRate);

              this._changeDetection.detectChanges();
            }
          });


     */
  }

  placeBetActive(value) {
    // //console.log('--placeBetActive--',value);

    this._DataHelper.ChangeOddIsActive = !value;

    this._UiHelper.placeBetIsActive = value;
  }

  placeBet() {
    this._DataHelper.currentSlipInfo.oddIsChange = false;
    window.scroll(0, 0);

    if (this._UserHelper.isSignedIn) {
      // this._UiHelper.setLoadingDialog(true);
      this._UiHelper.setLoadingTicketDialog(true);

      let systemValues = '';
      this.systemItems.forEach(cb => {
        if (cb.selected) {
          systemValues += '1,';
        } else {
          systemValues += '0,';
        }
      });
      if (systemValues != '') {
        systemValues = systemValues.substring(0, systemValues.length - 1);
      }

      if (this.timer_subscription != undefined) {
        this.timer_subscription.unsubscribe();
      }
      this.apiPlaceBet(systemValues);

      // this.timer = timer(1000, 1000);
      // this.timer_subscription = this.timer.subscribe(t => {
      //   this.BettingSlip_Countdown--;
      //   if (this.BettingSlip_Countdown == 0) {
      //     this.apiPlaceBet(systemValues);
      //     clearInterval(this.timer);
      //     this.timer = null;
      //     this.timer_subscription.unsubscribe();
      //     // Submit Bet
      //   }
      // });
      // this.BettingSlip_Countdown = 5;
    } else {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
      this.closeBottomSheet();
      this._UiHelper.setRightMenu();
      setTimeout(x => {
        window.scroll(0, 0);
      }, 200);
    }
  }
  apiPlaceBet(systemValues) {
    // Place Bet
    this._UiHelper.isLugasErrorActive = false;
    this._UiHelper.isLugasError5minute = false;

    this._UiHelper.flagRefreshCurrentSlip = false;
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService
      .placeBet(this._DataHelper.currentSlipInfo.toPayNumeric, this._UiHelper.currentSlipTabSelected, systemValues)
      .then(data => {
        this._UiHelper.setLoadingDialog(false);
        if (data.body == '') {
          this._UiHelper.flagRefreshCurrentSlip = true;
          return 'error|System Error';
        } else {
          if (data.body.split('|')[0] == 'error') {
            if (data.body.split('|')[1].trim() == 'error333' || data.body.split('|')[1].trim() == 'error333,') {
              this._UiHelper.flagRefreshCurrentSlip = true;
              this._UiHelper.isLugasErrorActive = true;
            } else if (data.body.split('|')[1].trim() == 'error334' || data.body.split('|')[1].trim() == 'error334,') {
              // this._UiHelper.errorSnackBar(data.body.split('|')[1], '');;

              this._UiHelper.flagRefreshCurrentSlip = true;
              this._UiHelper.isLugasError5minute = true;
            } else {
              this._UiHelper.flagRefreshCurrentSlip = true;
              this._UiHelper.errorSnackBar(data.body.split('|')[1], '');
            }
          } else if (data.body.split('|')[0] == 'errorcode') {
            // this._UiHelper.errorSnackBar(data.body.split('|')[1], '');

            const t_message = translator.transform(data.body.split('|')[1], null);

            this._UiHelper.errorSnackBar(t_message, '');
            this._UiHelper.flagRefreshCurrentSlip = true;
          } else if (data.body.split('|')[0].trim() == 'error333' || data.body.split('|')[0].trim() == 'error333,') {
            // this._UiHelper.errorSnackBar(data.body.split('|')[1], '');

            this._UiHelper.flagRefreshCurrentSlip = true;
            this._UiHelper.isLugasErrorActive = true;
          } else if (data.body.split('|')[0].trim() == 'error334' || data.body.split('|')[0].trim() == 'error334,') {
            // this._UiHelper.errorSnackBar(data.body.split('|')[1], '');

            this._UiHelper.flagRefreshCurrentSlip = true;
            this._UiHelper.isLugasError5minute = true;
          } else if (data.body.split('|')[0] == 'success') {
            pushToDataLayer({ event: 'betslip_complete', currency: 'euro', amount: this._DataHelper.currentSlipInfo.toPayNumeric });

            this._DataHelper.currentSlipInfo.currentslip_totalStake = DefaultSlipAmount;
            // this._UiHelper.b3000SetBottomDialogState('close');
            this._DataHelper.oldCouponList = JSON.parse(localStorage.getItem('currentslip'));
            this._ApiService.clearCurrentSlip();
            this._DataHelper.ChangeOddIsActive = true;
            this._UiHelper.placeBetIsActive = false;
            this._UiHelper.placedBetMessage = true;
            this._DataHelper.currentSlipData.length = 0;
            const t_message = translator.transform('successcode2', null);
            this._UiHelper.successSnackBar(t_message, '');
            this._ApiService.getSelectedOdds();

            if (environment.product === 'terminalPeru') {
              if (data.body.split('|')[2]) {
                const barcode = data.body.split('|')[2].toString();
                this.openPrintTicketDialog(barcode);
              }
            }

            // this.bottomSheetRef.dismiss();

            // rabbit mq'den aktığı için değişiklik hemen gözükmüyor bazen. Bu yüzden time out tanımlandı.
            setTimeout(() => this._DataService.fireApiCall('getSlipCashOutList', true, true), 1000);
            this.closeInformerModal.emit(true);

            // Bakiye güncellenmesi için.
            if (this._UserHelper.customerUser.CustomerId) {
              this._ApiService.getClient2().then();
            }
            this._ApiService.getSlips(new Date().getMonth(), new Date().getFullYear(), 1).then(x => {
              this.slipsList = [];
              if (x != undefined && x.length > 0) this.slipsList.push(x[0]);
            });
          } else {
            pushToDataLayer({ event: 'betslip_failed' });
            const t_message_err = translator.transform('errorcode3', null);
            this._UiHelper.errorSnackBar(t_message_err, '');
            this._UiHelper.flagRefreshCurrentSlip = true;
            throw new Error('Place Bet ' + data.body);
          }
        }
      })
      .catch(err => {
        console.error(err);
        this._UiHelper.setLoadingDialog(false);
      });
    // Place Bet
  }

  onBlurTotalStake(event): void {
    if (event.target.value === '' || event.target.value === '0') {
      event.target.value = MinSlipAmount;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = MinSlipAmount;
      this._DataService.fireApiCall('getCurrentSlipAmount');
      this._DataService.fireApiCall('refreshCurrentSlip');
    }
  }

  changeTotalStake(event) {
    const allowedCodes = [
      'Digit0',
      'Digit1',
      'Digit2',
      'Digit3',
      'Digit4',
      'Digit5',
      'Digit6',
      'Digit7',
      'Digit8',
      'Digit9',
      'Numpad0',
      'Numpad1',
      'Numpad2',
      'Numpad3',
      'Numpad4',
      'Numpad5',
      'Numpad6',
      'Numpad7',
      'Numpad8',
      'Numpad9',

      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ];

    const allowedKeys = ['.'];

    if (event && event.code && (allowedCodes.includes(event.code) || allowedKeys.includes(event.key))) {
      const newVal = event.target.value
        .split('.')
        .map((item, index) => (index === 1 ? `.${item.slice(0, 2)}` : item))
        .join('');
      event.target.value = newVal;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = newVal;
    } else {
      event.target.value = this._DataHelper.currentSlipInfo.currentslip_totalStake;
    }
    if (event.target.value === '') {
      // If there is no value, set the default value
      // Buggy here, no code.
    }

    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
  }

  getSystemItems() {
    this._DataService.fireApiCall('getSystemItems');
  }

  factorial(e) {
    if (e == 1 || e == 0) {
      return 1;
    } else {
      return e * this.factorial(e - 1);
    }
  }

  combination(r) {
    const n = this.systemItems.length;
    return this.factorial(n) / (this.factorial(n - r) * this.factorial(r));
  }

  changeAmount(event: any, index: number, combination: number) {
    const systemSelectKey = `${index + 1}_${combination}`;
    if (event.target.checked === true) {
      this._DataHelper.currentSlipSystemSelection = [...new Set([...this._DataHelper.currentSlipSystemSelection, systemSelectKey])];
      this._DataHelper.currentSlipInfo.isCheckIsSystem = true;
    } else {
      this._DataHelper.currentSlipSystemSelection = this._DataHelper.currentSlipSystemSelection.filter(x => x !== systemSelectKey);
      if (this._DataHelper.currentSlipSystemSelection && this._DataHelper.currentSlipSystemSelection.length === 0) {
        this._DataHelper.currentSlipInfo.isCheckIsSystem = false;
      }
    }
    this._DataService.fireApiCall('getCurrentSlipAmount', true);
  }

  currentSlipsTabsChange(e) {
    this._UiHelper.currentSlipTabSelected = e.index;
    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  changeSelectedSlipCurrent(e) {
    const enable = e.Enable;
    let bank = e.Banko;
    if (e.Banko) {
      bank = false;
    } else {
      bank = true;
    }

    if (e.eEvents != undefined && e.eEvents.length > 0) {
      // console.warn("e.eEvents", e.eEvents);
      e.eEvents.map(m => {
        this._ApiService.changeSelectedSlipCurrent(enable, bank, m.OddId1);
        return m;
      });
    }

    const oddId = e.OddId1;
    this._ApiService.changeSelectedSlipCurrent(enable, bank, oddId);
    this.changeTotalStakeInput();
    this._ApiService.getCurrentSlip();
    this.getSystemItems();
  }

  changeStakeInKeyboard(e) {
    /* this.totalStakeKeyboard = this._DataHelper.currentSlipInfo.currentslip_totalStake.toString();
     let num = parseInt(this.totalStakeKeyboard);
     if (num < 2 && e === -1) {
       ////console.log('below zero');
     } else {
       if (this.totalStakeKeyboard) {
         ////console.log(num, e);
         num += e;
         this._DataHelper.currentSlipInfo.currentslip_totalStake = num;
         this.totalStakeKeyboard= num.toString();
       } else {
         this._DataHelper.currentSlipInfo.currentslip_totalStake = e;
         this.totalStakeKeyboard = e.toString();
       }

     }

 */
    this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(e);

    if (this._UserHelper != undefined) {
      if (this._UserHelper.customerUser != undefined) {
        if (this._UserHelper.customerUser.Symbol == 'IQD' || this._UserHelper.customerUser.Symbol == 'IRR') {
          this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(e) * 1000;
        }
      }
    }

    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  changeStakeInKeyboardPlusMinus(e) {
    ////// console.warn('changeStakeInKeyboardPlusMinus', e);
    let tempAmount = Number(e);

    if (this._UserHelper != undefined) {
      if (this._UserHelper.customerUser != undefined) {
        if (this._UserHelper.customerUser.Symbol == 'IQD' || this._UserHelper.customerUser.Symbol == 'IRR') {
          tempAmount = Number(e) * 1000;
        }
      }
    }

    this.totalStakeKeyboard = this._DataHelper.currentSlipInfo.currentslip_totalStake.toString();

    let num = parseInt(this.totalStakeKeyboard);
    if (num < 2 && e === -1) {
      ////// console.log('below zero');
    } else {
      if (this.totalStakeKeyboard) {
        ////// console.log(num, e);
        num += tempAmount;
        this._DataHelper.currentSlipInfo.currentslip_totalStake = num;
        this.totalStakeKeyboard = num.toString();
      } else {
        this._DataHelper.currentSlipInfo.currentslip_totalStake = tempAmount;
        this.totalStakeKeyboard = e.toString();
      }
    }

    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  changeStakeInKeyboardCalculator(e) {
    let num = this.totalStakeKeyboard;

    //// console.log(e, num.split('.'));
    if (num.split('.').length === 1 || num.split('.')[1].length < 2) {
      if (this.totalStakeKeyboard) {
        //// console.log(num, e);
        num = num + '' + e;
        this._DataHelper.currentSlipInfo.currentslip_totalStake = parseFloat(num);
        this.totalStakeKeyboard = num;
      } else {
        this._DataHelper.currentSlipInfo.currentslip_totalStake = e;
        this.totalStakeKeyboard = e.toString();
      }

      this._DataService.fireApiCall('getCurrentSlipAmount');
    }
  }

  removeStakeInKeyboard() {
    this.totalStakeKeyboard = this.totalStakeKeyboard.slice(0, -1);
    this._DataHelper.currentSlipInfo.currentslip_totalStake = parseFloat(this.totalStakeKeyboard);

    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  getLiveEvent(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId == e);
      // ////console.log("MACTH-----",match);
      return match;
    } else {
      this._DataHelper.currentSlipData.length = 0;
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else {
      return e;
    }
  }

  ngOnDestroy() {
    // //console.log('DESTROY');
    this._DataHelper.ChangeOddIsActive = true;
    this._UiHelper.placeBetIsActive = false;

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this._UiHelper.placedBetMessage = false;
  }

  goEventDetail(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId == e.MatchId);
      this.closeBottomSheet();
      if (match == undefined) {
        this._router.navigate(['/eventdetail', e.MatchId]);
      } else {
        this._router.navigate(['/liveeventdetail', e.MatchId]);
      }
      return match;
    } else {
      this._DataHelper.currentSlipData.length = 0;
    }
  }

  changeKeyboardState(value: boolean) {
    this.keyboardIsOpen = value;
    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  changeBetSlipTab(tabId: 0 | 1 | 2) {
    // todo this control need to be move correct place
    if (this._DataHelper.currentSlipData.length < 2) {
      tabId = 0;
    }

    this._UiHelper.currentSlipTabSelected = tabId;
    this._UiHelper.setCurrentSlipTabSelected(tabId);
    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  slipHeaderChangeTab(tabId = 1) {
    this._UiHelper.setCurrentSlipHeaderTabSelected(tabId);
  }

  changeStakeInKeyboardB3000(e, option = '') {
    if (option == '') {
      this.stakeString += e;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == 'backspace') {
      this.stakeString = this.stakeString.slice(0, -1);
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
    } else if (option == '+10') {
      this.stakeString = (Number(this.stakeString) + 10).toString();
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == '+50') {
      this.stakeString = (Number(this.stakeString) + 50).toString();
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == 'C') {
      this.stakeString = '0';
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
    }
    if (this._DataHelper.taxRate != 0) {
      this._DataHelper.currentSlipInfo.toPayNumeric = (this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) / (100 + this._DataHelper.taxRate);
      this.tax = (this._DataHelper.currentSlipInfo.currentslip_totalStake - this._DataHelper.currentSlipInfo.toPayNumeric).toFixed(4);
      // console.warn("Tax", this.tax, this._DataHelper.currentSlipInfo.toPayNumeric );
    } else {
      this._DataHelper.currentSlipInfo.toPay = this._DataHelper.currentSlipInfo.currentslip_totalStake;
      this._DataHelper.currentSlipInfo.toPayNumeric = this._DataHelper.currentSlipInfo.toPay;
      this.tax = '';
    }
    // this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);

    if (this._UserHelper != undefined) {
      if (this._UserHelper.customerUser != undefined) {
        if (this._UserHelper.customerUser.Symbol == 'IQD' || this._UserHelper.customerUser.Symbol == 'IRR') {
          this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(e) * 1000;
        }
      }
    }
  }

  getTopLeague() {
    this._ApiService
      .getProcTournamentTopResult()
      .then((x: any) => {
        this.topLeaguesData = x;
      })
      .catch(err => console.log('current-slip.core', err));
  }

  getMatch(tournament) {
    this._UiHelper.b3000SetBottomDialogState('close');

    this.selectedLeagueData = [];
    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: tournament.TournamentName,
      SportId: 1,
      SportName: 'Fußball',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  restoreSlip() {
    this._ApiService.restoreSlip().then((x: any) => {
      this._ApiService.getCurrentSlip();
    });
  }

  toggleTicketDetails(id) {
    if (id == this.openedPanelId) {
      this.openedPanelId = 0;
    } else {
      this.openedPanelId = id;
    }
  }

  CurrentSlipBack() {
    this._UiHelper.b3000SetBottomDialogState('close');
  }

  getNumber(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return +val;
  }

  goEventDetailB3000(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId == e.MatchId);
      this._UiHelper.b3000SetBottomDialogState('close');
      if (match == undefined) {
        this._router.navigate(['/eventdetail', e.MatchId]);
      } else {
        this._router.navigate(['/liveeventdetail', e.MatchId]);
      }
      return match;
    } else {
      this._DataHelper.currentSlipData.length = 0;
    }
  }

  trackByFnSystemCombinations(index, item) {
    return item.index + '_' + item.combination;
  }
}

interface ITopLeagues {
  CategoryId: number;
  ExtensionData: any;
  IsoName: string;
  TournamentId: number;
  TournamentName: string;
  TournamentSportEventCount: number;
}
